module.exports = __webpack_public_path__ + "files/efa76206dabe8d6ad9c9eca0c94b208b.png";